import { render, staticRenderFns } from "./customerInformation.vue?vue&type=template&id=861ffec4"
import script from "./customerInformation.vue?vue&type=script&lang=js"
export * from "./customerInformation.vue?vue&type=script&lang=js"
import style0 from "./customerInformation.vue?vue&type=style&index=0&id=861ffec4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports